import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderTop: `solid 1px ${theme.colorPalette.beige_10}`,
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    padding: theme.spacing(4, 8),
    position: 'relative'
  },
  completed: {
    backgroundColor: theme.colorPalette.white_30
  },
  task: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  taskInfo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(2),
    width: '100%'
  },
  taskInfoCompleted: {
    gridTemplateColumns: '2fr 1fr'
  },
  taskName: {
    whiteSpace: 'nowrap',
    color: theme.colorPalette.green_15,
    lineHeight: 1.5
  },
  completedAt: {
    fontSize: 10,
    color: theme.colorPalette.green_15
  },
  completedTask: {
    color: theme.colorPalette.beige_75
  },
  tags: {
    marginTop: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: theme.colorPalette.beige_50,
    color: theme.colorPalette.green_90
  },
  upload: {
    fontSize: 12,
    fontWeight: 600
  },
  uploadIcon: {
    marginLeft: theme.spacing(2)
  },
  completedIcon: {
    height: 24,
    margin: 'auto 0',
    '--completed-icon-stroke': theme.colorPalette.green_50
  },
  progressBar: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0
  },
  filesTooltip: {
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: theme.sizes.roundCorners,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  fileName: {
    padding: theme.spacing(4),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.colorPalette.white_30
    }
  },
  taskNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  learnMoreLink: {
    width: 'auto',
    height: 'auto',
    borderRadius: theme.spacing(2),
    color: theme.colorPalette.orange_10,
    padding: 0,
    marginLeft: theme.spacing(0.2),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  learnMoreLinkText: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.colorPalette.orange_10
  },
  iconButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1)
  },
  actionButton: {
    color: theme.colorPalette.orange_10,
    fontSize: 12,
    fontWeight: 600
  },
  actionButtonIcon: {
    marginRight: theme.spacing(2)
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  tag: {
    fontWeight: 400,
    color: theme.colorPalette.green_90,
    backgroundColor: theme.colorPalette.beige_10,
    '& > img': {
      height: 14,
      margin: theme.spacing(0, 1)
    }
  },
  statusTag: {
    backgroundColor: 'white'
  },
  questionIcon: {
    height: 12,
    padding: theme.spacing(0, 0.5)
  },
  approvalSection: {
    width: '138%',
    maxWidth: '650px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(4),
    margin: theme.spacing(4, 0),
    backgroundColor: theme.colorPalette.beige_10,
    borderRadius: theme.spacing(2),
    '& > img': {
      height: 16,
      marginTop: theme.spacing(0.5),
      alignSelf: 'flex-start'
    }
  },
  approvalContent: {
    marginLeft: theme.spacing(2),
    '& > first-child': {
      marginBottom: theme.spacing(2)
    }
  },
  approvalButton: {
    backgroundColor: 'black',
    color: 'white',
    padding: theme.spacing(2),
    '& > img': {
      marginRight: theme.spacing(2)
    }
  }
});

export default makeStyles(styles);
